import React from 'react'
import { useLottie } from "lottie-react";
import animationData from './Burning-Fire.json';

export default function HottestRatesLottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
      const { View } = useLottie(defaultOptions);
      return (
        <div style={{ width: "30px", height: "50px" }} >
          {View}
        </div>
      );
  }
